module.exports = __webpack_public_path__ + "static/media/openstudy_03.955fbab6.jpg";